import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDom from 'react-dom';
import {StyleRoot} from 'radium';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import * as styles from '../../../styles';
import {request} from '../../../containers/actions';
import PrintStudentReport from './print_student';

export default class StudentReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        currentTab: 0,
        student: {},
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.fetchReport.bind(this)();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.student !== this.props.student ||
            (nextProps.examination && nextProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.setState({results: undefined, data: undefined, student: {}});
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.student !== this.props.student ||
            (prevProps.examination && prevProps.examination.id) !==
            (this.props.examination && this.props.examination.id)) {
            this.fetchReport.bind(this)();
        }
    }

    fetchReport() {
        this.setState({results: undefined, data: undefined, student: {}});
        if (!this.props.examination || _.keys(this.props.examination).length === 0)
            return;
        (async () => {
            const response = await this.context.store.dispatch(request({
                path: '/result/?' + queryString.stringify({
                    examination: this.props.examination.id,
                    report: null,
                    limit: 100,
                    ...(this.props.student
                        ? {student: this.props.student}
                        : {}
                    ),
                }),
            }));
            this.setState({
                results: response.results,
            });
        })();
        if (this.props.student) {
            (async () => {
                const response = await this.context.store.dispatch(request({
                    path: `/student/${this.props.student}/`,
                }));
                this.setState({
                    student: response,
                });
            })();
        }
        (async () => {
            const response = await this.context.store.dispatch(request({
                path: '/data/?' + queryString.stringify({
                    examination: this.props.examination.id,
                    limit: 10000,
                    ...(this.props.student
                        ? {student: this.props.student}
                        : {}
                    ),
                }),
            }));
            const data = response.results;
            const school = (_.find(data, data => (
                data.field === 31 &&
                data.student === Number.parseInt(this.props.student || this.context.user.id) &&
                data.category_is_global &&
                data.group_school
            )) || {'group_school': null}).group_school;
            if (school)
                (async () => {
                    const response = await this.context.store.dispatch(request({
                        path: `/school/${school}/`,
                    }));
                    this.setState({
                        school: response,
                    });
                })();
            this.setState({data});
        })();
    }

    render() {
        const subjects = _.mapKeys(this.props.examination.subjects, item => item.id);
        const rootSubjects = _.uniq(_.union(..._.map(
            this.props.examination.questions,
            item => _.map(item.subjects, item => item.root_subject),
        )));
        const levels = _.filter(
            _.uniqBy(_.map(this.props.examination.questions, item => item.level), 'id'),
            item => item,
        );
        const types = _.filter(
            _.uniqBy(_.map(this.props.examination.questions, item => item.question_type), 'id'),
            item => item,
        );
        const questions = _.mapKeys(this.props.examination.questions, item => item.id);
        const clazz = (_.find(this.state.data, data => (
            data.field === 31 &&
            data.student === (this.props.student || this.context.user.id) &&
            data.category_is_global &&
            data.group_class
        )) || {'group_class': null}).group_class;
        const Td = props => <td {...props} style={{...styles.softTd, ...(props.style || {})}}>{props.children}</td>;
        const Mtd = props => <td {...props} style={{...styles.softTd, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </td>;
        const Th = props => <th {...props} style={{...styles.softTh, ...(props.style || {})}}>{props.children}</th>;
        const Mth = props => <th {...props} style={{...styles.softTh, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </th>;
        return <span>
            <div style={{marginBottom: '.5em', display: 'inline-block', float: 'left'}}>
                <iframe
                    ref='print'
                    style={{width: '0', height: '0', border: 'none'}}
                    srcDoc={`<html>
    <head>
        <link rel="stylesheet" type="text/css" href="/css/mhelli.css">
        <style>
            @page {
                size: A4 Landscape;
                margin: 0;
            }
            body {
                background-color: white;
            }
        </style>
    </head>
    <body dir='rtl'>
        <span id='content'>
            <span style='font-family: IRANSans;'>1</span>
            <span style='font-family: IRANSans; font-weight: 700;'>1</span>
        </span>
    </body>
</html>`}/>
                <div>
                    {this.state.printing
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : <button
                            key='print'
                            style={{
                                ...styles.defaultButton,
                                float: 'left',
                                marginRight: '.5em',
                                backgroundColor: styles.fourthColor,
                            }}
                            onClick={async () => {
                                this.setState({printing: true});
                                const win = this.refs.print.contentWindow;
                                win.document.getElementById('content').innerHTML = '';
                                ReactDom.render(<StyleRoot>
                                    <PrintStudentReport
                                        last
                                        examination={this.props.examination}
                                        results={this.state.results}
                                        data={this.state.data}
                                        student={this.props.student
                                            ? this.state.student
                                            : this.context.user
                                        }
                                        school={this.state.school}
                                        imageLoaded={() => {
                                            win.print();
                                            this.setState({printing: false});
                                        }}
                                    />
                                </StyleRoot>, win.document.getElementById('content'));
                            }}>
                            {window.gettext('Print')}
                        </button>
                    }
                    <button
                        key='report'
                        style={{...styles.defaultButton, float: 'left', marginRight: '.5em'}}
                        onClick={() => {
                            const path = this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            );
                            this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/paper/'));
                        }}>
                        {window.gettext('Paper')}
                    </button>
                    <button
                        key='close'
                        style={{...styles.button, float: 'left', marginRight: '.5em'}}
                        onClick={() => {
                            const path = this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            );
                            this.context.store.dispatch(push(path.split('/').slice(0, -3).join('/') + '/'));
                        }}>
                        {window.gettext('Back')}
                    </button>
                </div>
            </div>
            {this.state.results
                ? <div
                    style={{
                        ...styles.box,
                        width: '100%',
                        display: 'inline-block',
                    }}>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Examination')}: {this.props.examination.title}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Name')}:
                        &nbsp;
                        {this.props.student ? this.state.student.firstname : this.context.user.firstname}
                        &nbsp;
                        {this.props.student ? this.state.student.lastname : this.context.user.lastname}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Holding Date')}: {(this.props.examination.date || '').toJalali().persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Analyze Date')}: {(this.props.examination.analyze_date || '').toJalali().persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Centers Participated')}:
                        &nbsp;
                        {(this.props.examination.schools_participated || '').persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Participants')}: {(this.props.examination.students_participated || '').persian()}
                    </div>
                    <div style={{float: 'right', width: '25%'}}>
                        {window.gettext('Rank')}:
                        &nbsp;
                        {(_.find(this.state.data, data => (
                            data.category_is_global &&
                            data.student &&
                            data.field === 31 &&
                            data.group_is_global
                        )) || {value: 0}).value.toFixed().persian()}
                    </div>
                </div>
                : null
            }
            <div
                style={{
                    ...styles.box,
                    marginTop: '1em',
                    width: '100%',
                    display: 'inline-block',
                }}>
                <table
                    style={{
                        borderCollapse: 'collapse',
                        fontSize: '1.1em',
                        border: '.0625em solid #eaeaea',
                        width: 'calc(60% - 2em)',
                        marginRight: '1em',
                    }}>
                    <thead>
                        <tr>
                            <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Total Score')}</Mth>
                            <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Score')}</Mth>
                            <Th rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Status')}</Th>
                            <Mth
                                colSpan='3'
                                style={{
                                    borderLeft: '.0625em solid #cacaca',
                                    borderRight: '.0625em solid #cacaca',
                                    lineHeight: undefined,
                                }}>
                                {window.gettext('Average')}
                            </Mth>
                            <Mth
                                colSpan='3'
                                style={{
                                    borderLeft: '.0625em solid #cacaca',
                                    borderRight: '.0625em solid #cacaca',
                                    lineHeight: undefined,
                                }}>
                                {window.gettext('Rank')}
                            </Mth>
                            <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Top 4th')}</Mth>
                        </tr>
                        <tr>
                            <Mth style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Class')}</Mth>
                            <Mth style={{lineHeight: undefined}}>{window.gettext('School')}</Mth>
                            <Mth style={{borderLeft: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Global')}</Mth>
                            <Mth style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Class')}</Mth>
                            <Mth style={{lineHeight: undefined}}>{window.gettext('School')}</Mth>
                            <Mth style={{borderLeft: '.0625em solid #cacaca', lineHeight: undefined}}>{window.gettext('Global')}</Mth>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <Mtd>
                                {_.sumBy(
                                    this.props.examination.questions,
                                    item => _.sumBy(item.scores, 'score'),
                                ).toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd>{_.sumBy(this.state.results, 'mark').persian()}</Mtd>
                            <Td>
                                {_.sumBy(this.state.results, 'mark').scoreStatus(_.sumBy(
                                    this.props.examination.questions,
                                    item => _.sumBy(item.scores, 'score'),
                                ))}
                            </Td>
                            <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.field === 21 &&
                                    data.clazz === clazz
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.field === 21 &&
                                    data.school
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd style={{borderLeft: '.0625em solid #cacaca'}}>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.field === 21 &&
                                    data.is_global
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.student &&
                                    data.field === 31 &&
                                    data.group_class
                                )) || {value: 0}).value.toFixed().persian()}
                            </Mtd>
                            <Mtd>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.student &&
                                    data.field === 31 &&
                                    data.group_school
                                )) || {value: 0}).value.toFixed().persian()}
                            </Mtd>
                            <Mtd style={{borderLeft: '.0625em solid #cacaca'}}>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.student &&
                                    data.field === 31 &&
                                    data.group_is_global
                                )) || {value: 0}).value.toFixed().persian()}
                            </Mtd>
                            <Mtd>
                                {(_.find(this.state.data, data => (
                                    data.category_is_global &&
                                    data.field === 23 &&
                                    data.is_global
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                        </tr>
                    </tbody>
                </table>
                <div
                    style={{
                        justifyContent: 'space-around',
                        width: '100%',
                    }}>
                    <div
                        style={{
                            flexGrow: '1',
                            textAlign: 'center',
                            padding: '1em',
                            float: 'right',
                            width: '60%',
                            boxSizing: 'border-box',
                        }}>
                        <span>
                            {window.gettext('Examining the status of the student in subjects of the examinaiton')}
                        </span>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                border: '.0625em solid #eaeaea',
                            }}>
                            <thead>
                                <tr>
                                    <Th>{window.gettext('Index')}</Th>
                                    <Th>{window.gettext('Subject')}</Th>
                                    <Mth>{window.gettext('Count')}</Mth>
                                    <Mth>{window.gettext('Total Score')}</Mth>
                                    <Mth>{window.gettext('Score')}</Mth>
                                    <Mth>{window.gettext('Status')}</Mth>
                                    <Mth>{window.gettext('Average')}</Mth>
                                    <Mth>{window.gettext('Top 4th')}</Mth>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    _.sortBy(rootSubjects),
                                    (subject, index) => <tr key={subject}>
                                        <Td>{(index + 1).persian()}</Td>
                                        <Td>{subjects[subject].title}</Td>
                                        <Mtd>
                                            {_.size(_.filter(
                                                this.props.examination.questions,
                                                item => _.some(item.subjects, item => item.root_subject === subject),
                                            )).persian()}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.props.examination.questions,
                                                    item => _.some(item.subjects, item => item.root_subject === subject),
                                                ),
                                                item => _.sumBy(item.scores, 'score'),
                                            ).toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.state.results,
                                                    item => _.some(
                                                        questions[item.question].subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                'mark',
                                            ).toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {_.sumBy(
                                                _.filter(
                                                    this.state.results,
                                                    item => _.some(
                                                        questions[item.question].subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                'mark',
                                            ).scoreStatus(_.sumBy(
                                                _.filter(
                                                    this.props.examination.questions,
                                                    item => _.some(
                                                        item.subjects,
                                                        item => item.root_subject === subject,
                                                    ),
                                                ),
                                                item => _.sumBy(item.scores, 'score'),
                                            ))}
                                        </Mtd>
                                        <Mtd>
                                            {(_.find(this.state.data, data => (
                                                data.subject === subject &&
                                                data.field === 21 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>
                                            {(_.find(this.state.data, data => (
                                                data.subject === subject &&
                                                data.field === 23 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                    </tr>,
                                )}
                            </tbody>
                        </table>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-around',
                                width: '100%',
                            }}>
                            <div style={{flexGrow: '1', textAlign: 'center', paddingLeft: '1em', paddingTop: '2em'}}>
                                <span>
                                    {window.gettext('Examining the status of the student in different levels of questions')}
                                </span>
                                <table
                                    style={{
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        border: '.0625em solid #eaeaea',
                                    }}>
                                    <thead>
                                        <tr>
                                            <Th>{window.gettext('Index')}</Th>
                                            <Th>{window.gettext('Level')}</Th>
                                            <Mth>{window.gettext('Count')}</Mth>
                                            <Mth>{window.gettext('Total Score')}</Mth>
                                            <Mth>{window.gettext('Score')}</Mth>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            _.sortBy(levels, 'id'),
                                            (level, index) => <tr key={level.id}>
                                                <Td>{(index + 1).persian()}</Td>
                                                <Td>{level.title}</Td>
                                                <Mtd>
                                                    {_.size(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.level && item.level.id === level.id,
                                                    )).persian()}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.level && item.level.id === level.id,
                                                    ), item => _.sumBy(item.scores, 'score')).toFixed(2).persian(true)}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.state.results,
                                                        item => questions[item.question].level &&
                                                        questions[item.question].level.id === level.id,
                                                    ), 'mark').toFixed(2).persian(true)}
                                                </Mtd>
                                            </tr>,
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div style={{flexGrow: '1', textAlign: 'center', paddingRight: '1em', paddingTop: '2em'}}>
                                <span>
                                    {window.gettext('Examining the status of the student in different types of questions')}
                                </span>
                                <table
                                    style={{
                                        borderCollapse: 'collapse',
                                        width: '100%',
                                        border: '.0625em solid #eaeaea',
                                    }}>
                                    <thead>
                                        <tr>
                                            <Th>{window.gettext('Index')}</Th>
                                            <Th>{window.gettext('Type')}</Th>
                                            <Mth>{window.gettext('Count')}</Mth>
                                            <Mth>{window.gettext('Total Score')}</Mth>
                                            <Mth>{window.gettext('Score')}</Mth>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(
                                            _.sortBy(types, 'id'),
                                            (type, index) => <tr key={type.id}>
                                                <Td>{(index + 1).persian()}</Td>
                                                <Td>{type.title}</Td>
                                                <Mtd>
                                                    {_.size(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.question_type &&
                                                        item.question_type.id === type.id,
                                                    )).persian()}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.props.examination.questions,
                                                        item => item.question_type &&
                                                        item.question_type.id === type.id,
                                                    ), item => _.sumBy(item.scores, 'score')).toFixed(2).persian(true)}
                                                </Mtd>
                                                <Mtd>
                                                    {_.sumBy(_.filter(
                                                        this.state.results,
                                                        item => questions[item.question].question_type &&
                                                        questions[item.question].question_type.id === type.id,
                                                    ), 'mark').toFixed(2).persian(true)}
                                                </Mtd>
                                            </tr>,
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            flexGrow: '1',
                            textAlign: 'center',
                            padding: '1em',
                            float: 'right',
                            width: '40%',
                            boxSizing: 'border-box',
                        }}>
                        <span>
                            {window.gettext('Examining the operation of the student each question')}
                        </span>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                border: '.0625em solid #eaeaea',
                            }}>
                            <thead>
                                <tr>
                                    <Th>{window.gettext('Question')}</Th>
                                    <Th>{window.gettext('Subject')}</Th>
                                    <Mth>{window.gettext('Total Score')}</Mth>
                                    <Mth>{window.gettext('Score')}</Mth>
                                    <Mth>{window.gettext('Average')}</Mth>
                                </tr>
                            </thead>
                            <tbody>
                                {_.map(
                                    _.sortBy(this.state.results, item => questions[item.question].index),
                                    ({question, mark}) => <tr key={question}>
                                        <Td>{(questions[question].index + 1).persian()}</Td>
                                        <Td style={{maxWidth: '16.5em', textOverflow: 'ellipsis', overflow: 'hidden'}}>
                                            {_.map(
                                                _.uniq(_.union(..._.map(
                                                    questions[question].subjects,
                                                    item => _.reverse(_.slice(item.subjects)),
                                                ))),
                                                (item, index) => index === 0 && subjects[item].title.length > 14
                                                ? subjects[item].title.substr(0, 14) + '…'
                                                : subjects[item].title,
                                            ).join(' - ')}
                                        </Td>
                                        <Mtd>
                                            {_.sumBy(questions[question].scores, 'score').toFixed(2).persian(true)}
                                        </Mtd>
                                        <Mtd>{mark.toFixed(2).persian(true)}</Mtd>
                                        <Mtd>
                                            {(_.find(this.state.data, data => (
                                                data.question === question &&
                                                data.field === 21 &&
                                                data.is_global
                                            )) || {value: 0}).value.toFixed(2).persian(true)}
                                        </Mtd>
                                    </tr>,
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </span>;
    }
};
